import { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import {updateThreshold} from '../../services/sensorGraphs/sensorGraphsService';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { VARIABLES_WITH_ADJUSTED_CE, VARIABLES_WITH_ADJUSTED_PH } from '../utils/Constants';


const ModalUpdateThreshold = ({
    showModalThresholdInterGraph,
    initialMaxThresholdGraph,
    actualMaxThresholdGraph,
    initialMinThresholdGraph,
    actualMinThresholdGraph,
    unitsGraph,
    varIdGraph,
    sensorIdGraph,
    setShowModalThreshold,
    onThresholdSaved
}) => {
    
    // Utilizar props directamente en lugar de duplicar estados
    const [actualMaxThreshold, setActualMaxThreshold] = useState(actualMaxThresholdGraph);
    const [actualMinThreshold, setActualMinThreshold] = useState(actualMinThresholdGraph);
    const [isSaving, setIsSaving] = useState(false);  // Para manejar el estado de guardado

    const isDecimalVariable = [...VARIABLES_WITH_ADJUSTED_PH, ...VARIABLES_WITH_ADJUSTED_CE].includes(varIdGraph);
    const step = isDecimalVariable ? 0.1 : 1;

    useEffect(() => {
        // Sincronizar valores internos con las props cada vez que cambien
        setActualMaxThreshold(actualMaxThresholdGraph);
        setActualMinThreshold(actualMinThresholdGraph);
    }, [actualMaxThresholdGraph, actualMinThresholdGraph]);

    const handleChangeThreshold = (type, value) => {
        // Redondear a 1 decimal para evitar errores de coma flotante (ej: 6.1000000000001)
        const realValue = isDecimalVariable ? Math.round(Number(value) * 10) / 10 : Number(value);
        if (type === 'max' && realValue > actualMinThreshold) {
            setActualMaxThreshold(realValue);
        } else if (type === 'min' && realValue < actualMaxThreshold) {
            setActualMinThreshold(realValue);
        }
    };

    const handleUpdateThreshold = () => {
        setIsSaving(true); // Indicar que se está guardando
        const threshold = {
            variableId: varIdGraph,
            sensorId: sensorIdGraph,
            minValue: actualMinThreshold,
            maxValue: actualMaxThreshold,
            minLimit: initialMinThresholdGraph,
            maxLimit: initialMaxThresholdGraph
        };

        updateThreshold(threshold)
        .then(() => {
            setIsSaving(false);
            onThresholdSaved({ max: actualMaxThreshold, min: actualMinThreshold });
            setShowModalThreshold(false);  // Cierra el modal después de guardar
        })
        .catch((error) => {
            setIsSaving(false);
            // La sesión vencida (401) la maneja el interceptor global; otro error deja el modal abierto
            if (error.response?.status === 401) return;
            console.error('Error al guardar el umbral: ', error);
            alert(error.response?.status === 403
                ? 'No tienes permiso para cambiar los umbrales de este sensor.'
                : 'No se pudo guardar el umbral, intenta de nuevo.');
        });
    };

    return (
        <Modal show={showModalThresholdInterGraph} onHide={() => setShowModalThreshold(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>Modifica tu nuevo umbral máximo y mínimo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>Valor máximo</h4>
                <h6>Umbral guardado previamente: {`${actualMaxThresholdGraph} ${unitsGraph}`}</h6>
                <Slider
                    value={actualMaxThreshold}
                    min={initialMinThresholdGraph}
                    max={initialMaxThresholdGraph}
                    step={step}
                    onChange={(value) => handleChangeThreshold('max', value)}
                />
                <br />
                <h6>Nuevo valor máximo:</h6>
                <Form.Control
                    readOnly
                    type="text"
                    placeholder="Valor máximo"
                    value={`${actualMaxThreshold} ${unitsGraph}`}
                />
                <hr />
                <h4>Valor mínimo</h4>
                <h6>Umbral guardado previamente: {`${actualMinThresholdGraph} ${unitsGraph}`}</h6>
                <Slider
                    value={actualMinThreshold}
                    min={initialMinThresholdGraph}
                    max={initialMaxThresholdGraph}
                    step={step}
                    onChange={(value) => handleChangeThreshold('min', value)}
                />
                <br />
                <h6>Nuevo valor mínimo:</h6>
                <Form.Control
                    readOnly
                    type="text"
                    placeholder="Valor mínimo"
                    value={`${actualMinThreshold} ${unitsGraph}`}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={() => setShowModalThreshold(false)}>
                    Cancelar
                </Button>
                <Button 
                    variant="success" 
                    onClick={handleUpdateThreshold} 
                    disabled={isSaving} // Deshabilitar el botón mientras se guarda
                >
                    {isSaving ? 'Guardando...' : 'Guardar cambios'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalUpdateThreshold;